export const fall_2026_2260_calendar = [
/***WEEK 1***/
{
    weekNumber: 1,
    entries: [
        {
            date: "August 18 (Tuesday)",
            topic: "",
            items: [
                "Quiz 0",
                "Approximating area, integrals",
                "Homework:  §1.1 #13,15,19; §1.2 #73; §1.3 #171-189 (odd)"
            ]
        },
        {
            date: "August 19 (Wednesday)",
            topic: "",
            items: [
"Integrals Review (in class activity)"
            ]
        },
        {
            date: "August 20 (Thursday)",
            topic: "",
            items: [
                "Substitution",
                "Homework: §1.5 #271-287 odd; §1.6 #327-341 (odd); §1.7 #391-401 (odd)"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 2***/
{
    weekNumber: 2,
    entries: [
        {
            date: "August 25 (Tuesday)",
            topic: "",
            items: [
                "Quiz 1",
                "Area between curves, volumes",
                "Homework: §2.1 #7-25 odd; §2.2 #75-81"
            ]
        },
        {
            date: "August 26 (Wednesday)",
            topic: "",
            items: [
                "Volumes of rotation (in class activity)"
            ]
        },
        {
            date: "August 27 (Thursday)",
            topic: "",
            items: [
                "Volumes, arc length, surface area",
                    "Homework: §2.3 #121,123,125,127,129,143; §2.4 #181,183,185,187,199,201",
                    "Some physical applications of integration",
                    "Homework: §2.5 225-243 (odd)"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 3***/
{
    weekNumber: 3,
    entries: [
        {
            date: "September 1 (Tuesday)",
            topic: "",
            items: [
                "Quiz 2",
                "Center of mass",
                "Homework: §2.6 255,257,259, 273-279 (odd)"
            ]
        },
        {
            date: "September 2 (Wednesday)",
            topic: "",
            items: [
                "More applications of integration (in class activity)"
            ]
        },
        {
            date: "September 3 (Thursday)",
            topic: "",
            items: [
                "No class!"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 4***/
{
    weekNumber: 4,
    entries: [
        {
            date: "September 8 (Tuesday)",
            topic: "",
            items: [
                "Quiz 3",
                "Integration by parts",
                "Homework: §3.1 1-19 (odd), 21-47 (odd)",
                "Work on Some Integrals assignemnt, due 9/15"
            ]
        },
        {
            date: "September 9 (Wednesday)",
            topic: "",
            items: [
                "No class!"
            ]
        },
        {
            date: "September 10 (Thursday)",
            topic: "",
            items: [
                "No class!"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 5***/
{
    weekNumber: 5,
    entries: [
        {
            date: "September 15 (Tuesday)",
            topic: "",
            items: [
                "Turn in Some Integrals take home assignment before class (Quiz 4)",
                "Trigonometric Integrals",
                    "Homework: §3.2 79-103 (odd)",
                    "Trigonometric substitution",
                    "Homework: §3.3 135-153 (odd)"
            ]
        },
        {
            date: "September 16 (Wednesday)",
            topic: "",
            items: ["Some Trig Integrals (in class activity)"]
        },
        {
            date: "September 17 (Thursday)",
            topic: "",
            items: [
                    "Partial fraction decomposition",
                    "Homework: §3.4 197-209 (odd)"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 6***/
{
    weekNumber: 6,
    entries: [
        {
            date: "September 22 (Tuesday)",
            topic: "",
            items: [
                "Quiz 5",
                "Improper integrals",
                    "Homework: §3.7 347-371 (odd)"
            ]
        },
        {
            date: "September 23 (Wednesday)",
            topic: "",
            items: [
                "Review"
            ]
        },
        {
            date: "September 24 (Thursday)",
            topic: "",
            items: [
                "Exam 1"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 7***/
{
    weekNumber: 7,
    entries: [
        {
            date: "September 29 (Tuesday)",
            topic: "",
            items: [
                "No Quiz",
                    "Sequences",
                    "Homework: §5.1 1-43 (odd)"
            ]
        },
        {
            date: "September 30 (Wednesday)",
            topic: "",
            items: ["Improper Integrals and Sequences (in class activity)"]
        },
        {
            date: "October 1 (Thursday)",
            topic: "",
            items: ["Sequences",
                    "Homework: §5.1 1-43 (odd)",
                    "Series",
                    "Homework: §5.2 67,69,71,73,81,93,95; §5.3 145-161 (odd)"]
        }
    ]
},
/***END WEEK***/

/***WEEK 8***/
{
    weekNumber: 8,
    entries: [
        {
            date: "October 6 (Tuesday)",
            topic: "",
            items: ["Quiz 6",
                "Comparison Tests",
                "Homework: §5.4 195-223 (odd)"
            ]
        },
        {
            date: "October 7 (Wednesday)",
            topic: "",
            items: ["Series (in class activity)"]
        },
        {
            date: "October 8 (Thursday)",
            topic: "",
            items: [
                 "Alternating series",
                    "Homework: §5.5 251-265 (odd); 283,285 "
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 9***/
{
    weekNumber: 9,
    entries: [
        {
            date: "October 13 (Tuesday)",
            topic: "",
            items: ["Quiz 7",
                "Ratio and root test",
                    "Homework: §5.6 317-341 (odd) "]
        },
        {
            date: "October 14 (Wednesday)",
            topic: "",
            items: ["More Series (in class activity)"]
        },
        {
            date: "October 15 (Thursday)",
            topic: "",
            items: [
                "Power series",
                    "Homework: §6.1 13-21, 33-41 (odd)"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 10***/
{
    weekNumber: 10,
    entries: [
        {
            date: "October 20 (Tuesday)",
            topic: "",
            items: [
                "Quiz 8",
                "Power series",
                    "§6.2 79-99 (odd)"
            ]
        },
        {
            date: "October 21 (Wednesday)",
            topic: "",
            items: ["Power Series (in class activity)"]
        },
        {
            date: "October 22 (Thursday)",
            topic: "",
            items: [
                "Taylor and Maclaurin series",
                    "Homework: §6.3 117-123 (odd)"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 11***/
{
    weekNumber: 11,
    entries: [
        {
            date: "October 27 (Tuesday)",
            topic: "",
            items: ["More on Taylor's formula"]
        },
        {
            date: "October 28 (Wednesday)",
            topic: "",
            items: ["Review"]
        },
        {
            date: "October 29 (Thursday)",
            topic: "",
            items: ["Exam 2"]
        }
    ]
},
/***END WEEK***/

/***WEEK 12***/
{
    weekNumber: 12,
    entries: [
        {
            date: "November 3 (Tuesday)",
            topic: "",
            items: ["Some examples with series"]
        },
        {
            date: "November 4 (Wednesday)",
            topic: "",
            items: ["Vectors in class activity",
                "Switch to using Calculus Vol. 3 on OpenStax!",
                    "Read Vol. 3, §2.1; #1-33 (odd)",
                    "Vectors in three dimensions, the dot and cross product",
                    "Homework §2.2 (Vol 3) 83-93 (odd)"
            ]
        },
        {
            date: "November 5 (Thursday)",
            topic: "",
            items: []
        }
    ]
},
/***END WEEK***/

/***WEEK 13***/
{
    weekNumber: 13,
    entries: [
        {
            date: "November 10 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "November 11 (Wednesday)",
            topic: "",
            items: []
        },
        {
            date: "November 12 (Thursday)",
            topic: "",
            items: []
        }
    ]
},
/***END WEEK***/

/***WEEK 14***/
{
    weekNumber: 14,
    entries: [
        {
            date: "November 17 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "November 18 (Wednesday)",
            topic: "",
            items: []
        },
        {
            date: "November 19 (Thursday)",
            topic: "",
            items: [
                "Exam 3"
            ]
        }
    ]
},
/***END WEEK***/

/***WEEK 15***/
{
    weekNumber: 15,
    entries: [
        {
            date: "November 24 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "November 25 (Wednesday)",
            topic: "",
            items: []
        },
        {
            date: "November 26 (Thursday)",
            topic: "",
            items: []
        }
    ]
},
/***END WEEK***/

/***WEEK 16***/
{
    weekNumber: 16,
    entries: [
        {
            date: "December 1 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "December 2 (Wednesday)",
            topic: "",
            items: []
        },
        {
            date: "December 3 (Thursday)",
            topic: "",
            items: []
        }
    ]
},
/***END WEEK***/

/***WEEK 17***/
{
    weekNumber: 17,
    entries: [
        {
            date: "December 8 (Tuesday)",
            topic: "",
            items: []
        },
        {
            date: "December 9 (Wednesday)",
            topic: "",
            items: []
        },
        {
            date: "December 10 (Thursday)",
            topic: "",
            items: []
        }
    ]
},
/***END WEEK***/

];


// WEBPACK FOOTER //
// ./src/data/calendars/fall_2026_2260_calendar.js